<template>
    <!-- <div class="app-wrapper" :class="classObj">
        <navbar></navbar>
        <sidebar class="sidebar-container"></sidebar>
        <div class="main-container">
            <app-main></app-main>
        </div>
    </div> -->
    <el-row>
        
        <navbar></navbar>
        <div class="app-wrapper" :class="classObj">
        <el-col :span="4">
              <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened" ></hamburger> 
             <sidebar class="sidebar-container">
                
             </sidebar>
        </el-col>
       <el-col :span="24">
            <div class="main-container">
            <app-main></app-main>
        </div>
       </el-col>
        </div>
    </el-row>
</template>
<script>
import {Navbar,Sidebar,AppMain} from './components'
import ResizeMixin from './mixin/ResizeHandler'
import Hamburger from '@/components/Hamburger'
import { mapGetters } from 'vuex'
export default {
    name:'layout',
    components:{
        Navbar,
        Sidebar,
        AppMain,
        Hamburger
    },
    mixins: [ResizeMixin],
    methods:{
        toggleSideBar() {
            this.$store.dispatch('ToggleSideBar')
        },
    },
    computed:{
        sidebar() {
            return this.$store.state.app.sidebar
        },
        device() {
            return this.$store.state.app.device
        },
        classObj(){
            return {
                hideSidebar: !this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile'
            }
        },
        ...mapGetters([
            'sidebar'
        ]),
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
  .hamburger-container{
      position: absolute;
    //   margin-left: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/Layout.vue